'use strict';

import $ from 'jquery';

class Navigation {

  constructor(){
    this.mobileNav = document.querySelectorAll('.header .mobile-nav');
    this.mobileNavContent = document.querySelectorAll('.mobile-nav__content');
  }

  mobileNavigation(){

    // mobile-nav toggler button
    $(document.body).on('click','.mobile-nav .dropdown-toggle',function(event){
      event.preventDefault();
      event.stopPropagation();
      $('.mobile-nav').toggleClass('open');
      $(document.body).toggleClass('mobile-nav-open');
    });

    // click outside toggle button closes mobile menu
    $(document.body).on('click',function(){
      $('.mobile-nav').toggleClass('open',false);
      $(this).toggleClass('mobile-nav-open',false);
    });

  }

  init(){
    this.mobileNavigation();
  }
}

export default new Navigation();

